<template>
  <div :id="`ellevio-modal-${modalData.type}`" data-modal-target class="hidden">
    <ellevio-web-modal-content v-if="modalData.type === 'content' || modalData.type === 'projectMap'" :params="modalData" />
    <ellevio-web-modal-image-and-text v-if="modalData.type === 'imageAndText'" :params="modalData" />
  </div>
</template>

<script>
import EllevioWebModalContent from './ModalContent.vue'
import EllevioWebModalImageAndText from './ModalImageAndText.vue'

import { modal as initModal } from '../../../scripts/modal'
import store from '../../../store/web'

//libs close method needs to update vuex onclose
const modal = initModal(() => store.dispatch('modalOpen', null))

export default {
  name: 'EllevioWebModal',
  components: {
    EllevioWebModalContent,
    EllevioWebModalImageAndText
  },
  data() {
    return {
      modalData: {}
    }
  },
  computed: {
    modalActive() {
      return store.state.modal?.type ?? ''
    },
    modalObj() {
      return store.state.modal ?? {}
    }
  },
  watch: {
    modalActive(newValue, oldValue) {
      if (newValue) {
        this.modalData = this.modalObj
        setTimeout(() => {
          modal.openModal(`ellevio-modal-${newValue}`)
        }, 0)
      } else {
        setTimeout(() => {
          this.modalData = {}
        }, 300)
        try {
          modal.closeModal(document.getElementById(`ellevio-modal-${oldValue}`))
        } catch (error) {
          //console.log('modal already closed')
        }
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      /*
      using modal lib from https://github.com/tomaszbujnowicz/vanilla-js-tailwindcss-modal
      examples here https://tomaszbujnowicz.github.io/vanilla-js-tailwindcss-modal/
      */

      modal.init()

      /*
      //Example opening modal on mount + action with delay
      store.dispatch('modalOpen', 'test1');
      //no support for opening second modal before closing the first
      setTimeout(function(){
        console.log('Test trigger close after five seconds')
        store.dispatch('modalClose');
      }, 5000)
      */
    })
  }
}
</script>

<style></style>
